/* eslint react-hooks/rules-of-hooks: "warn" */
import { Message } from '@meitu/saas-ui';
import { useFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { LayerType } from '@/version-types';
import { ContextMenuPluginDependency } from '../../../dependency';
import { IExportContextMenuItem, IRenderContextMenuItemArgs } from '../../../type';
import MenuItem from '../../../views/menu-item';

const render = ({ operateLayerType, isImageEditor }: IRenderContextMenuItemArgs) => {
    const { $t } = getLocaleStore();
    const framework = useFramework();

    if (isImageEditor) return null;
    if (operateLayerType !== LayerType.BACKGROUND_LAYER) return null;

    const item = {
        name: $t((v) => v.contextMenuLayer.menuConfig.backgroundSplit),
        type: 'backgroundSplit',
        icon: 'SeparateBackgroundBold',
        onClick: () => {
            framework.getInstance(ContextMenuPluginDependency).convertBackgroundToImage();
            Message.success($t((v) => v.contextMenuLayer.menu.successText));
        },
    };

    return <MenuItem {...item}></MenuItem>;
};

export default {
    group: 1,
    sort: 3,
    render,
} as IExportContextMenuItem;
